export default {
  getUser: (state) => state.userInfo,
};
